import { InputSelect } from "../../../components/forms/inputs/InputSelect";
import { LISI_COMPARE_CRITERIA, LISI_COMPARE_SOURCE, LISI_COMPARE_TO } from "../../../services/dashboard/lisi-dashboard-service";
import { useState } from "react";
import { Panel } from "../../../components/panels/Panel";
import { PlayIcon } from "@heroicons/react/20/solid";

export const LisiDashboardGlobalRequestor = () => {

  const [criteria, setCriteria] = useState(LISI_COMPARE_CRITERIA[0]);
  const [source, setSource] = useState(LISI_COMPARE_SOURCE[0]);
  const [to, setTo] = useState(LISI_COMPARE_TO[0]);
  const [displayedCriteria, setDisplayedCriteria] = useState(LISI_COMPARE_CRITERIA[0]);
  const [displayedSource, setDisplayedSource] = useState(LISI_COMPARE_SOURCE[0]);
  const [displayedTo, setDisplayedTo] = useState(LISI_COMPARE_TO[0]);
  const [results, setResults] = useState(null);

  const sendRequest = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_ADDRESS + 'request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          request_name: criteria.value,
          start_1: Math.floor(source.start / 1000),
          stop_1: Math.floor(source.stop / 1000),
          start_2: Math.floor(to.start / 1000),
          stop_2: Math.floor(to.stop / 1000),
        }),
      });

      const data = await response.json();
      setResults(data);
      // setResults({ value_1: 10, value_2: 20, delta: [10], delta_pct: 100 });
      setDisplayedCriteria(criteria);
      setDisplayedSource(source);
      setDisplayedTo(to);

    } catch (error) {
      console.error('Error while requesting data.', error);
      alert('Error while requesting data.');
    }
  };

  const FormattedResults = ({ displayedSource, displayedTo, displayedCriteria, results }) => {
    const ColoredScore = ({ score, type = "index" }) => {
      if (score === 0)
        return <div className='text-2xl'>-</div>

      let colorClass = '';
      let roundedScore;
      if (type === "index") {
        roundedScore = score * 10 / 10;
        if (roundedScore >= 80) colorClass = "rgba(75, 255, 192, 0.8)";   // Green
        else if (roundedScore >= 60) colorClass = "rgba(255, 206, 86, 0.8)"; // Yellow
        else if (roundedScore >= 40) colorClass = "rgba(255, 150, 86, 0.8)"; // Orange
        else if (roundedScore >= 20) colorClass = "rgba(255, 99, 132, 0.8)"; // Red
        else colorClass = "rgba(255, 120, 150, 0.9)";                // Bright red
      }
      else {
        colorClass = 'white';
        roundedScore = score;
      }
      return <div className="text-2xl" style={{ color: colorClass}}>{roundedScore}</div>
    }

    return (
      <div className="h-full flex flex-col gap-4">
        <div className="h-full max-h-20 flex w-full gap-4">
          <div className="w-full bg-perception-black-700 rounded-md p-4 flex flex-col items-center justify-center text-center gap-2">
            <ColoredScore score={results?.value_1?.[0]} type={displayedCriteria.value === 'reba_mean' ? 'reba' : 'index'}/>
            <div className="text-sm">Sur {displayedSource.label.toLowerCase()}</div>
          </div>
          <div className="w-full bg-perception-black-700 rounded-md p-4 flex flex-col items-center justify-center text-center gap-2">
            <ColoredScore score={results?.value_2?.[0]} type={displayedCriteria.value === 'reba_mean' ? 'reba' : 'index'}/>
            <div className="text-sm">Sur {displayedTo.label.toLowerCase()}</div>
          </div>
        </div>
        <div className="w-full bg-perception-black-700 rounded-md p-4 flex flex-col items-center justify-center text-center gap-2">
          <ColoredScore score={`${results?.delta_pct?.[0] >= 0 ? '+' : ''}${results?.delta_pct?.[0] * 10 / 10}%`} type={'other'}/>
          <div className="text-sm">Tendance</div>
        </div>
      </div>
    );
  };

  return (
    <Panel title="EXPLORATEUR DE DONNEES" rounded width="w-1/3">
      <div className="h-full flex flex-col">
        <div className="grid grid-cols-[auto] gap-x-4 gap-y-2 items-center">
          <div className="">Je souhaite comparer</div>
          <InputSelect
            items={LISI_COMPARE_CRITERIA}
            onChange={setCriteria}
            itemToString={(item) => item?.label}
            defaultValue={LISI_COMPARE_CRITERIA[0]}
          />

          <div className="">entre</div>
          <InputSelect
            items={LISI_COMPARE_SOURCE}
            onChange={setSource}
            itemToString={(item) => item?.label}
            defaultValue={LISI_COMPARE_SOURCE[0]}
          />

          <div className="">et</div>
          <InputSelect
            items={LISI_COMPARE_TO}
            onChange={setTo}
            itemToString={(item) => item?.label}
            defaultValue={LISI_COMPARE_TO[0]}
          />
        </div>

        <div>
          {
            results && results?.delta?.length > 0 ?
              <div className="h-full flex flex-col justify-center items-center gap-8 mt-6">
                <button className="bg-perception-blue text-white px-4 py-2 rounded-md flex items-center" onClick={sendRequest}>
                  <PlayIcon aria-hidden="true" className="size-5 mr-2" /> Comparer
                </button>
                <FormattedResults
                  displayedSource={displayedSource}
                  displayedTo={displayedTo}
                  displayedCriteria={displayedCriteria}
                  results={results}
                />
              </div>
              :
              <div className="h-full flex flex-col justify-center items-center text-perception-gray-800 text-center gap-4">
                <button className="bg-perception-blue text-white px-4 py-2 rounded-md flex items-center mt-4" onClick={sendRequest}>
                  <PlayIcon aria-hidden="true" className="size-5 mr-2" /> Comparer
                </button>
                {
                  results?.delta?.length === 0 ?
                    <p>Aucun résultat pour les critères sélectionnés.<br/>Lancez une autre comparaison pour obtenir les résultats.</p>
                    : <p>Lancez une comparaison pour obtenir les résultats.</p>
                }
              </div>
          }
        </div>
      </div>
    </Panel>
  );
};